import { useTranslation } from 'react-i18next';

const STEP_BGS = ['bg-candy-cyan', 'bg-candy-pink', 'bg-candy-yellow'];

export const HowItWorks = () => {
  const { t } = useTranslation();
  const steps = t('how.steps', { returnObjects: true });

  return (
    <section id="how" aria-labelledby="how-title" className="mx-auto max-w-content px-4 py-10 md:px-6 md:py-[60px]" data-testid="how-it-works-section">
      <div className="rounded-block-lg bg-candy-ink px-6 py-10 text-candy-bg md:px-12 md:py-14">
        <h2 id="how-title" className="font-heading text-[clamp(32px,3.6vw,48px)] font-extrabold leading-none tracking-[-0.035em]">
          {t('how.title')}
        </h2>
        <ol className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-3">
          {steps.map((step, i) => (
            <li key={step.title} data-testid={`step-${i}`} className="rounded-3xl bg-candy-dark-card p-7">
              <span
                className={`grid h-[52px] w-[52px] place-items-center rounded-2xl font-heading text-xl font-extrabold text-candy-ink ${STEP_BGS[i % STEP_BGS.length]}`}
                aria-hidden="true"
              >
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mb-1.5 mt-5 font-heading text-2xl font-bold">{step.title}</h3>
              <p className="text-candy-on-dark-muted">{step.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
